import {
  Body,
  DetailsModalPropsType,
  FlexContainer,
  Span,
  useLocales,
  useModal,
} from "@/lib/main";
import { type CSSProperties } from "react";

export default function DetailsModal({
  id,
  label,
  labelStyle,
  heading,
  headingAlign,
  headingFontWeight,
  text,
  textAlign,
}: DetailsModalPropsType) {
  const l = useLocales();
  const { showModal, setShowModal, setContent } = useModal();

  const labelStyles: CSSProperties = {
    cursor: "pointer",
    fontSize: "inherit",
    ...labelStyle,
  };
  const textStyle: CSSProperties = { whiteSpace: "pre-wrap" };

  const handleLabelClick = () => {
    if (showModal) return;

    setContent(
      <FlexContainer direction="column" fullWidth id={id}>
        {heading ? (
          <Body
            lineHeight="2.25"
            style={textStyle}
            textAlign={headingAlign}
            fontWeight={headingFontWeight || 400}
          >
            {l(heading)}
          </Body>
        ) : null}

        {Array.isArray(text) ? (
          text.map((paragraph, index) => (
            <Body
              key={index}
              lineHeight="2.25"
              style={textStyle}
              textAlign={textAlign}
            >
              {l(paragraph)}
            </Body>
          ))
        ) : (
          <Body lineHeight="2.25" style={textStyle} textAlign={textAlign}>
            {l(text)}
          </Body>
        )}
      </FlexContainer>,
    );

    setShowModal(true);
  };

  return (
    <Span color="link" onClick={handleLabelClick} style={labelStyles}>
      {l(label)}
    </Span>
  );
}
